export default "__VITE_ASSET__Bv_p64nJ__"